import { useState } from 'react';
import { NAV_ITEMS, ORGANIZATION_NAME, ORGANIZATION_SHORT } from '../constants';
import { jumpToAnchor } from '../utils/anchor-navigation';

function Header() {
  const [open, setOpen] = useState(false);

  const handleNav = (event, href) => {
    jumpToAnchor(event, href);
    setOpen(false);
  };

  return (
    <header className="sticky top-0 z-40 border-b border-hub-forest/10 bg-hub-cream/90 backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4">
        <a href="#top" onClick={(event) => handleNav(event, '#top')} className="flex items-center gap-3">
          <span className="grid h-11 w-11 place-items-center rounded-2xl bg-hub-forest text-sm font-black text-hub-cream shadow-soft">
            {ORGANIZATION_SHORT}
          </span>
          <span className="hidden font-display text-2xl font-bold text-hub-forest sm:block">
            {ORGANIZATION_NAME}
          </span>
        </a>

        <nav className="hidden items-center gap-6 text-xs font-bold uppercase tracking-[0.2em] text-hub-muted lg:flex" aria-label="Primary">
          {NAV_ITEMS.map((item) => (
            <a key={item.href} href={item.href} onClick={(event) => handleNav(event, item.href)} className="transition hover:text-hub-coral">
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a href="#join" onClick={(event) => handleNav(event, '#join')} className="hidden rounded-full bg-hub-coral px-5 py-3 text-xs font-black uppercase tracking-[0.18em] text-white transition hover:bg-hub-forest sm:inline-flex">
            Get involved
          </a>
          <button
            type="button"
            aria-expanded={open}
            aria-controls="mobile-nav"
            onClick={() => setOpen((value) => !value)}
            className="grid h-11 w-11 place-items-center rounded-full border border-hub-forest/20 bg-hub-paper font-bold text-hub-forest lg:hidden"
          >
            <span className="sr-only">Toggle navigation</span>
            <span aria-hidden="true">{open ? '×' : '☰'}</span>
          </button>
        </div>
      </div>

      {open && (
        <nav id="mobile-nav" className="border-t border-hub-forest/10 bg-hub-paper lg:hidden" aria-label="Mobile">
          <div className="mx-auto grid max-w-7xl px-5 py-3">
            {NAV_ITEMS.map((item) => (
              <a key={item.href} href={item.href} onClick={(event) => handleNav(event, item.href)} className="border-b border-hub-forest/10 py-4 text-sm font-black uppercase tracking-[0.2em] text-hub-forest last:border-0">
                {item.label}
              </a>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
}

export default Header;
